<script type="text/javascript">
    //盘口接口地址
    let KAIPAN_URL = 'http://10.10.197.4/pc/index/getKaipan';
    //banner图地址
    let BANNER_URL = 'http://10.10.197.4/pc/index/getBanner';
    //资讯列表接口
    let NEWS_URL = 'http://10.10.197.4/pc/News/getNews';
    //资讯详情接口列表
    let NEWS_DETAIL_URL = 'http://10.10.197.4/pc/News/getNewsDetail';
    //彩种详情接口
    let LOTTO_DETAIL_URL = 'http://10.10.197.4/pc/index/getLottoDetail';
    //眯牌调取盘口开奖接口
    let LOTTO_MIPAI_URL = 'http://10.10.197.4/pc/index/getLottoDetail';
    //公告内容接口地址
    let NOTICES_URL = 'http://10.10.197.4/pc/index/getNotices';
    //广告接口地址
    let ADVERT_URL="http://10.10.197.4/pc/index/getAdvert";
    //彩种长龙
    let LONG_URL = 'http://10.10.197.4/pc/Longqueue/index';
    let LONG_LIST_URL = 'http://10.10.197.4/pc/Longqueue/lottoList';
    //走势图
    let CHAR_URL = 'http://10.10.197.4/pc/index/index';
    //露珠
    let DROP_URL = 'http://10.10.197.4/pc/index/DewDrop';
    //资讯新闻top
    let NEW_SKILL_URL = 'http://10.10.197.4/pc/News/getTop';
    /*//盘口接口地址
    let KAIPAN_URL = 'http://caixun.com/pc/index/getKaipan';
    //banner图地址
    let BANNER_URL = 'http://caixun.com/pc/index/getBanner';
    //资讯列表接口
    let NEWS_URL = 'http://caixun.com/pc/News/getNews';
    //资讯详情接口列表
    let NEWS_DETAIL_URL = 'http://caixun.com/pc/News/getNewsDetail';
    //彩种详情接口
    let LOTTO_DETAIL_URL = 'http://caixun.com/pc/index/getLottoDetail';
    //眯牌调取盘口开奖接口
    let LOTTO_MIPAI_URL = 'http://caixun.com/pc/index/getLottoDetail';
    //公告内容接口地址
    let NOTICES_URL = 'http://caixun.com/pc/index/getNotices';
    //广告接口地址
    let ADVERT_URL="http://caixun.com/pc/index/getAdvert";
    //彩种长龙
    let LONG_URL = 'http://caixun.com/pc/Longqueue/index';
    let LONG_LIST_URL = 'http://caixun.com/pc/Longqueue/lottoList';
    //走势图
    let CHAR_URL = 'http://caixun.com/pc/index/index';
    //露珠
    let DROP_URL = 'http://caixun.com/pc/index/DewDrop';
    //资讯新闻top
    let NEW_SKILL_URL = 'http://caixun.com/pc/News/getTop';
    */
    let PanKouAjax_Interval_time = 5000; //盘口获取自动调用时间
    export default {
        NOTICES_URL,
        BANNER_URL,
        KAIPAN_URL,
        LOTTO_DETAIL_URL,
        NEWS_URL,
        ADVERT_URL,
        LONG_URL,
        LONG_LIST_URL,
        CHAR_URL,
        DROP_URL,
        NEWS_DETAIL_URL,
        NEW_SKILL_URL,
        PanKouAjax_Interval_time
    }
</script>


// WEBPACK FOOTER //
// src/components/Global.vue